const { zipCodeRegexNumeric, onlyNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumeric(zipCode);
  if (zip.length <= 3) {
    return zip;
  }
  return `${zip.slice(0, 3)} ${zip.slice(3, 5)}`;
};

exports.countryDefinition = {
  country: 'Czech Republic',
  code: 'CZ',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town/Post Office', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 123 45'
    }
  ]
};
